/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { ColumnResizedEvent } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { useEffect, useState } from "react";
import {
  faTrashCan,
  faMagnifyingGlass,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "ag-grid-community/styles/ag-grid.css";
import { DeleteTileModal } from "../components/Tile-management/DeleteTileModal";
import { AddTileModal } from "../components/Tile-management/AddTileModal";
import { TileDetailsModal } from "../components/Tile-management/TileDetailsModal";
import { PillInfo } from "../../../services/types/gallus";
import Select, { SingleValue } from "react-select";
import { ReactSelectOption } from "../../Interfaces";
import {
  useAddPillMutation,
  useDeletePillMutation,
  useLazyGetPillsByWorkspaceQuery,
  useUpdatePillMutation,
} from "../../../services/gallusTools";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

interface AdminTileManagementProps {
  environmentCode: "PR_PROD_" | "PR_UAT_";
}

interface AdminTileList {
  name: string;
  url: string;
}

export const AdminTileManagement = (props: AdminTileManagementProps) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [errorModalIsOpen, setErrorModalIsOpen] = useState<boolean>(false);
  const [deleteTileModalIsOpen, setDeleteTileModalIsOpen] =
    useState<boolean>(false);
  const [addTileModalIsOpen, setAddTileModalIsOpen] = useState<boolean>(false);
  const [TileDetailsModalIsOpen, setTileDetailsModalIsOpen] =
    useState<boolean>(false);
  const [TileData, setTileData] = useState<AdminTileList[]>([]);
  const [selectedTileID, setSelectedTileID] = useState<number>();
  const workspaceOptions: ReactSelectOption[] = [
    { value: props.environmentCode + "Executive", label: "Executive" },
    { value: props.environmentCode + "Operations", label: "Operations" },
    { value: props.environmentCode + "Retail", label: "Retail" },
    { value: props.environmentCode + "Wholesale", label: "Wholesale" },
  ];
  const [workspace, setWorkspace] = useState<ReactSelectOption>(
    workspaceOptions[0],
  );

  const [getTilesQuery, getTilesQueryResult] =
    useLazyGetPillsByWorkspaceQuery();
  const [addTileQuery, addTileQueryResult] = useAddPillMutation();
  const [updateTileQuery, updateTileQueryResult] = useUpdatePillMutation();
  const [deleteTileQuery, deleteTileQueryResult] = useDeletePillMutation();

  useEffect(() => {
    if (addTileQueryResult.isError) {
      setErrorModalIsOpen(true);
    }
  }, [addTileQueryResult]);

  useEffect(() => {
    if (updateTileQueryResult.isError) {
      setErrorModalIsOpen(true);
    }
  }, [updateTileQueryResult]);

  const toggleAddTileModal = () => {
    setAddTileModalIsOpen(!addTileModalIsOpen);
  };

  const toggleTileDetailsModal = () => {
    setTileDetailsModalIsOpen(!TileDetailsModalIsOpen);
  };

  const toggleDeleteTileModal = () => {
    setDeleteTileModalIsOpen(!deleteTileModalIsOpen);
  };

  /*   const [lazyGetTilesQuery, lazyGetTilesResults] =
    useLazyGetTilesQuery(); */

  const columnDefinitions = [
    { field: "name", headerName: "Name" },
    { field: "url", headerName: "URL" },
    {
      field: "options",
      headerName: "Options",
      cellRenderer: (params: { value: string }) => {
        return (
          <div>
            <button
              className="button-no-background"
              onClick={() => {
                if (typeof params.value !== "undefined") {
                  setSelectedTileID(Number(params.value));
                  setTileDetailsModalIsOpen(true);
                }
              }}
            >
              <FontAwesomeIcon className="me-2" icon={faMagnifyingGlass} />
            </button>
            <button
              className="button-no-background"
              onClick={() => {
                if (typeof params.value !== "undefined") {
                  setSelectedTileID(Number(params.value));
                  setDeleteTileModalIsOpen(true);
                }
              }}
            >
              <FontAwesomeIcon className="me-2" icon={faTrashCan} />
            </button>
          </div>
        );
      },
    },
  ];

  const generateTileRowData = (Tiles: PillInfo[]) => {
    return Tiles.map((Tile) => {
      return {
        name: Tile.title,
        url: Tile.link,
        options: Tile.id,
      };
    });
  };

  /*   useEffect(() => {
    if (
      getTilesResult.isSuccess &&
      getTilesResult.status === "fulfilled"
    ) {
      if (getTilesResult.data) {
        setTileData(generateTileRowData(getTilesResult.data.userList));
      }
      setLoading(false);
    }
  }, [getTilesResult]); */

  useEffect(() => {
    if (workspace) {
      setLoading(true);
      getTilesQuery({ workspace: workspace.value });
    }
  }, [workspace]);

  useEffect(() => {
    if (
      getTilesQueryResult.isSuccess &&
      getTilesQueryResult.status === "fulfilled"
    ) {
      setTileData(generateTileRowData(getTilesQueryResult.data));
      setLoading(false);
    }
  }, [getTilesQueryResult]);

  function onGridReady(params: ColumnResizedEvent) {
    params.api.sizeColumnsToFit();
  }

  return (
    <div className="container roundedCorners">
      <div className="mb-2">
        <div
          className="col-12 module-title"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          Landing Page Management
          {props.environmentCode === "PR_PROD_" ? " (Prod)" : " (UAT)"}
        </div>
      </div>
      {loading && (
        <div className="loading-div">
          <FontAwesomeIcon
            icon={faSpinner}
            size="2x"
            spin={true}
            style={{ margin: "0 auto" }}
          />
        </div>
      )}
      {!loading && (
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              paddingBottom: "20px",
            }}
          >
            <div>
              Select Workspace:
              <Select
                placeholder="Select Workspace"
                onChange={(
                  selectedWorkspace: SingleValue<ReactSelectOption>,
                ) => {
                  if (selectedWorkspace !== null) {
                    setWorkspace(selectedWorkspace);
                  }
                }}
                options={workspaceOptions}
                className="basic-multi-select width-min-200"
                classNamePrefix="select"
                value={workspace}
              />
            </div>
            <div>
              <button
                className="btn btn-primary"
                type="submit"
                disabled={loading}
                onClick={() => setAddTileModalIsOpen(true)}
              >
                Add Tile
              </button>
            </div>
          </div>
          <div>
            <AgGridReact
              domLayout={"autoHeight"}
              defaultColDef={{
                cellClass: "grid-generic-text",
                headerClass: "grid-generic-column",
              }}
              onGridReady={onGridReady}
              rowData={TileData}
              columnDefs={columnDefinitions}
            />
          </div>
        </div>
      )}
      <DeleteTileModal
        selectedTileID={selectedTileID!}
        deleteTileFunction={() => {
          if (selectedTileID) {
            deleteTileQuery({ pillID: selectedTileID });
          }
        }}
        modalIsOpen={deleteTileModalIsOpen}
        toggleModal={toggleDeleteTileModal}
      />
      <TileDetailsModal
        modalIsOpen={TileDetailsModalIsOpen}
        selectedTileID={selectedTileID!}
        updateTileFunction={(title: string, url: string) => {
          if (selectedTileID) {
            updateTileQuery({
              id: selectedTileID.toString(),
              title,
              url,
              workspace: workspace.value,
            });
          }
        }}
        toggleModal={toggleTileDetailsModal}
      />
      <AddTileModal
        addTileFunction={(title: string, url: string) => {
          addTileQuery({ title, url, workspace: workspace.value });
        }}
        selectedWorkspace={workspace.value}
        modalIsOpen={addTileModalIsOpen}
        toggleModal={toggleAddTileModal}
      />
      <Modal
        isOpen={errorModalIsOpen}
        toggle={() => setErrorModalIsOpen(!errorModalIsOpen)}
      >
        <ModalHeader toggle={() => setErrorModalIsOpen(!errorModalIsOpen)}>
          Invalid URL
        </ModalHeader>
        <div>
          <ModalBody>
            <div>
              <div
                style={{
                  fontSize: "larger",
                  paddingBottom: "5px",
                }}
              >
                You have submitted an invalid URL. Please make sure the URL
                includes liveboard GUID.
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              color="primary"
              onClick={() => {
                setErrorModalIsOpen(false);
              }}
            >
              Close
            </Button>
          </ModalFooter>
        </div>
      </Modal>
    </div>
  );
};
